import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import roleRoutes from "../routes/roleRoutes";
import { logout } from "../redux/slices/auth";
import { getNormalizedRole } from "../utils/UserRole";

const Sidebar = ({ isSidebarOpen, setIsSidebarOpen, handleClose }) => {
  const user = useSelector((state) => state.login.user);
  // Initial width set
  const role = user?.role;
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  // Early return only after hooks are called
  if (!role) return null;

  const normalizedRole = getNormalizedRole(role);
  const routes = roleRoutes[normalizedRole] || [];

  // Helper function to check if a link is active
  const isActiveRoute = (path) => {
    const fullPath = path ? `/dashboard/${path}` : `/dashboard`;
    return location.pathname === fullPath;
  };

  return (
    <aside
      className={`fixed top-0 left-0 z-40 w-64 h-screen pt-20 transition-transform bg-gray-100 ${
        isSidebarOpen ? "translate-x-0" : "-translate-x-full"
      } border-r border-gray-200 sm:translate-x-0 dark:bg-gray-800 dark:border-gray-700`}
      aria-label="Sidebar"
    >
      <div className="h-full px-3 py-3 pb-4 overflow-y-auto dark:bg-gray-800">
        <ul className="space-y-2 font-medium">
          {routes.map(({ path, name, icon: Icon }, idx) => {
            const isActive = isActiveRoute(path);
            return (
              <li key={idx}>
                <Link
                  to={idx === 0 ? "/dashboard" : `/dashboard/${path}`}
                  onClick={handleClose}
                  className={`flex items-center p-2 rounded-lg ${
                    isActive
                      ? "bg-gray-300 text-gray-900"
                      : "text-gray-900 hover:bg-gray-100 dark:text-black dark:hover:bg-gray-200"
                  }`}
                  aria-current={isActive ? "page" : undefined}
                >
                  {Icon && <Icon className="w-5 h-5 text-gray-500" />}
                  <span className="ml-3">{name}</span>
                </Link>
              </li>
            );
          })}
          <li>
            <button
              onClick={handleLogout}
              className="flex items-center p-2 rounded-lg text-red-600 hover:bg-red-100 dark:hover:bg-red-200 w-full"
            >
              <span className="ml-3 font-semibold text-[18px]">Logout</span>
            </button>
          </li>
        </ul>
      </div>
    </aside>
  );
};

export default Sidebar;
